module.exports = import("https://js.arcgis.com/calcite-components/3.3.3/calcite.esm.js");;